import { useQuery } from '@tanstack/react-query'
import { useAccessToken, useDistributionPrincipal } from '@dss/auth'
import { getPortalAccess, getPortalSession } from '@dss/api-client'
import { api } from '../../lib/api'

export function usePortalSession(enabled = true) {
  const token = useAccessToken()
  const principal = useDistributionPrincipal()
  const identity = `${principal?.distributorId}:${principal?.userId}`
  return useQuery({ queryKey: ['portal-session', identity, principal?.authorizationVersion ?? 0,
    [...new Set(principal?.roles ?? [])].sort(), [...new Set(principal?.permissions ?? [])].sort()],
    queryFn: () => getPortalSession(api, token!),
    enabled: Boolean(enabled && token && principal && !principal.isPlatformAdmin),
    retry: false, staleTime: 0 })
}

export function useClientGroupAccess(enabled = true) {
  const token = useAccessToken()
  const principal = useDistributionPrincipal()
  const identity = `${principal?.distributorId}:${principal?.userId}`
  return useQuery({ queryKey: ['portal-access', identity, principal?.authorizationVersion ?? 0,
    [...new Set(principal?.roles ?? [])].sort(), [...new Set(principal?.permissions ?? [])].sort()],
    queryFn: ({ signal }) => getPortalAccess(api, token!, signal),
    enabled: Boolean(enabled && token && principal && !principal.isPlatformAdmin),
    retry: false, staleTime: 0 })
}
